import { render, staticRenderFns } from "./OnlineStores.vue?vue&type=template&id=846d5fa0&"
import script from "./OnlineStores.vue?vue&type=script&lang=js&"
export * from "./OnlineStores.vue?vue&type=script&lang=js&"
import style0 from "./OnlineStores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports